var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-for-guest-button"},[_c('button',{staticClass:"for-guest-button",attrs:{"type":"button"},on:{"click":_vm.handleClick}},[_c('span',{staticClass:"for-guest-button-text"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }